import { useInfiniteQuery } from "react-query";
import axios from "axios";

const getPaginatedCompaniesForPortfolio = async ({
  apiSlug,
  searchQuery,
  companyIds,
  baselinePortfolioTagIds,
  marketTagIds,
  locationTagIds,
  portfolioTagIds,
  investmentRoundTagIds,
  visibility,
  sortBy,
  orderBy,
  offset,
  limit,
}) => {
  let pathAndHost = window.location.protocol + window.location.host;

  let url = new URL(`/api/v2/${apiSlug}`, pathAndHost);

  if (searchQuery) {
    url.searchParams.append("q", searchQuery);
  }

  //companyIds provided limit the set of companies to return to be
  //one of the provided companies in the list as the baseline set
  if (companyIds && companyIds.length > 0) {
    url.searchParams.append("company_ids", companyIds.join(","));
  }

  if (baselinePortfolioTagIds && baselinePortfolioTagIds.length > 0) {
    url.searchParams.append(
      "baseline_portfolio_tag_ids",
      baselinePortfolioTagIds.join(",")
    );
  }

  if (marketTagIds && marketTagIds.length > 0) {
    url.searchParams.append("market_tag_ids", marketTagIds.join(","));
  }

  if (locationTagIds && locationTagIds.length > 0) {
    url.searchParams.append("location_tag_ids", locationTagIds.join(","));
  }

  if (portfolioTagIds && portfolioTagIds.length > 0) {
    url.searchParams.append("portfolio_tag_ids", portfolioTagIds.join(","));
  }

  if (investmentRoundTagIds && investmentRoundTagIds.length > 0) {
    url.searchParams.append(
      "investment_round_tag_ids",
      investmentRoundTagIds.join(",")
    );
  }

  if (visibility) {
    url.searchParams.append("visibility", visibility.join(","));
  }

  if (sortBy) {
    url.searchParams.append("sort_by", sortBy);
  }

  if (orderBy) {
    url.searchParams.append("order_by", orderBy);
  }

  if (offset) {
    url.searchParams.append("offset", offset);
  }

  if (limit) {
    url.searchParams.append("limit", limit);
  }

  const { data: companies } = await axios.get(url.href);

  return companies;
};
export default function usePaginatedCompanies({
  apiSlug = "/companies",
  searchQuery,
  companyIds,
  baselinePortfolioTagIds,
  marketTagIds,
  locationTagIds,
  portfolioTagIds,
  investmentRoundTagIds,
  visibility,
  sortBy,
  orderBy,
  offset,
  limit,
  //additionalQueryString: props.additionalQueryString + searchStrings,
}) {
  return useInfiniteQuery(
    [
      "companies",
      {
        apiSlug,
        searchQuery,
        companyIds,
        baselinePortfolioTagIds,
        marketTagIds,
        locationTagIds,
        portfolioTagIds,
        investmentRoundTagIds,
        visibility,
        sortBy,
        orderBy,
        offset,
        limit,
      },
    ],
    async ({ pageParam }) =>
      getPaginatedCompaniesForPortfolio({
        apiSlug,
        searchQuery,
        companyIds,
        baselinePortfolioTagIds,
        marketTagIds,
        locationTagIds,
        portfolioTagIds,
        investmentRoundTagIds,
        visibility,
        sortBy,
        orderBy,
        offset: pageParam,
        limit,
      }),
    {
      getNextPageParam: (lastPage, allPages) => {
        let count = allPages.map((post) => post.data).flat().length;
        return count < lastPage.pagination.count ? count : false;
      },
      refetchOnWindowFocus: false,
    }
  );
}
